import script from "./city.vue?vue&type=script&setup=true&lang=js"
export * from "./city.vue?vue&type=script&setup=true&lang=js"

import "./city.vue?vue&type=style&index=0&id=2aef8e94&lang=less"

const __exports__ = script;

export default __exports__